import { createUseStyles } from "react-jss";
import { getDirectionDefaults, getGap } from "./Spacer.helpers.js";
const useStyles = createUseStyles(
  {
    wrapper: (props) => {
      var _a;
      return {
        display: "flex",
        gap: getGap(props == null ? void 0 : props.gap),
        ...getDirectionDefaults(props == null ? void 0 : props.direction),
        ...(props == null ? void 0 : props.centered) ? { alignItems: "center", justifyContent: "center" } : {},
        // note: centered overrides the alignItems and justifyContent from getDirectionDefaults
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.wrapper,
        ...props == null ? void 0 : props.style
      };
    }
  },
  { name: "ECSpacer" }
);
export {
  useStyles
};
//# sourceMappingURL=Spacer.styles.js.map
